/* eslint-disable jsx-a11y/iframe-has-title */
import { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import emailjs from "emailjs-com";
import "./Contact.css";
import Skeleton from "react-loading-skeleton";

const Contact = ({ contactUsData, aboutLoading, aboutError }) => {
  const [formData, setFormData] = useState({
    fullname: "",
    email: "",
    message: "",
  });

  const [isSending, setIsSending] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const isFormValid =
    formData.fullname.trim() !== "" &&
    formData.email.trim() !== "" &&
    formData.message.trim() !== "";

  const sendEmail = (e) => {
    e.preventDefault();
    setIsSending(true); // بدء الإرسال

    emailjs
      .sendForm(
        "service_hv2k77s",
        "template_eov40ch",
        e.target,
        "4Yb2j9xKIKrEXLpsG"
      )
      .then(
        (result) => {
          console.log(result.text);
          toast.success(
            "Thank you for your message. I'll get back to you soon."
          );
          e.target.reset();
          setFormData({ fullname: "", email: "", message: "" });
        },
        (error) => {
          console.log(error.text);
          toast.error("Something went wrong, try again.");
        }
      )
      .finally(() => {
        setIsSending(false);
      });
  };

  return (
    <>
      {/* #CONTACT */}
      <article className="contact" data-page="contact">
        <header>
          <h2 className="h2 article-title">Contact</h2>
        </header>
        <section className="mapbox" data-mapbox>
          <figure>
            {aboutLoading ? (
              <Skeleton width={"100%"} height={400} />
            ) : aboutError ? (
              <p>Error loading map data.</p>
            ) : (
              <iframe
                src={contactUsData.location}
                width="400"
                height="300"
                loading="lazy"
              ></iframe>
            )}
          </figure>
        </section>
        <section className="contact-form">
          <h3 className="h3 form-title">Contact Form</h3>
          <form onSubmit={sendEmail} className="form" data-form>
            <div className="input-wrapper">
              <input
                type="text"
                name="fullname"
                value={formData.fullname}
                onChange={handleChange}
                className="form-input"
                placeholder="Full name"
                required
                data-form-input
              />
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                placeholder="Email address"
                required
                data-form-input
              />
            </div>
            <textarea
              name="message"
              value={formData.message}
              onChange={handleChange}
              className="form-input"
              placeholder="Your Message"
              required
              data-form-input
            ></textarea>
            <button
              className="form-btn"
              type="submit"
              disabled={!isFormValid || isSending}
              data-form-btn
            >
              {isSending ? (
                <>
                  <ion-icon name="paper-plane"></ion-icon>
                  <span className="sending-animation">
                    Sending <span className="dots"></span>
                  </span>
                </>
              ) : (
                <>
                  <ion-icon name="paper-plane"></ion-icon>
                  <span>Send Message</span>
                </>
              )}
            </button>
          </form>
        </section>
      </article>

      {/* Toast container */}
      <ToastContainer
        position="bottom-right"
        autoClose={3000}
        hideProgressBar
        closeOnClick
        draggable
        pauseOnHover
        pauseOnFocusLoss
        theme="dark"
        toastStyle={{
          borderRadius: "10px",
          background: "#333",
          color: "#fff",
        }}
      />
    </>
  );
};

export default Contact;
